"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportEventBannerTheme = exports.BannerZoneSettings = exports.BannerZoneLocation = exports.TimePeriod = exports.BannerZonePlatform = exports.BannerZoneSportType = void 0;
var BannerZoneSportType;
(function (BannerZoneSportType) {
    BannerZoneSportType["MIX"] = "mix";
    BannerZoneSportType["ESPORT"] = "esport";
    BannerZoneSportType["CLASSIC"] = "classic";
})(BannerZoneSportType = exports.BannerZoneSportType || (exports.BannerZoneSportType = {}));
var BannerZonePlatform;
(function (BannerZonePlatform) {
    BannerZonePlatform["DESKTOP"] = "desktop";
    BannerZonePlatform["MOBILE"] = "mobile";
    BannerZonePlatform["IOS"] = "ios";
    BannerZonePlatform["ANDROID"] = "android";
})(BannerZonePlatform = exports.BannerZonePlatform || (exports.BannerZonePlatform = {}));
var TimePeriod;
(function (TimePeriod) {
    TimePeriod[TimePeriod["Daily"] = 0] = "Daily";
    TimePeriod[TimePeriod["Weekly"] = 1] = "Weekly";
    TimePeriod[TimePeriod["Monthly"] = 2] = "Monthly";
    TimePeriod[TimePeriod["MonthlyFull"] = 3] = "MonthlyFull";
})(TimePeriod = exports.TimePeriod || (exports.TimePeriod = {}));
var BannerZoneLocation;
(function (BannerZoneLocation) {
    BannerZoneLocation["TOP"] = "top";
    BannerZoneLocation["BOTTOM"] = "bottom";
    BannerZoneLocation["LEFT"] = "left";
    BannerZoneLocation["RIGHT"] = "right";
    BannerZoneLocation["RIGHT_TOP_SPORT_EVENTS"] = "right_top_sport_events";
    BannerZoneLocation["TOP_SLIDER"] = "top_slider";
    BannerZoneLocation["TOP_OUTRIGHTS_SLIDER"] = "top_outrights_slider";
    BannerZoneLocation["RIGHT_SLIDER"] = "right_slider";
    BannerZoneLocation["EVENTS_OF_THE_DAY_SLIDER"] = "events_of_the_day_slider";
    BannerZoneLocation["TOP_SPORT_EVENTS"] = "top_sport_events";
    BannerZoneLocation["POPULAR_SPORT_EVENTS"] = "popular_sport_events";
    BannerZoneLocation["FAVORITES_SPORT_EVENTS"] = "favorites_sport_events";
})(BannerZoneLocation = exports.BannerZoneLocation || (exports.BannerZoneLocation = {}));
var BannerZoneSettings;
(function (BannerZoneSettings) {
    BannerZoneSettings["INTERVAL"] = "interval";
})(BannerZoneSettings = exports.BannerZoneSettings || (exports.BannerZoneSettings = {}));
var SportEventBannerTheme;
(function (SportEventBannerTheme) {
    SportEventBannerTheme["OutrightMultiple"] = "outrightMultiple";
    SportEventBannerTheme["Colorful"] = "colorful";
})(SportEventBannerTheme = exports.SportEventBannerTheme || (exports.SportEventBannerTheme = {}));
//# sourceMappingURL=bannerZones.js.map